import { get, set, remove } from '../utils/IonicStorage'
/**
 IonicStorage is a wrapper around LocalStorage, SessionStorage and IndexedDB that makes it easy to store key/value pairs and JSON objects.
 https://ionicframework.com/docs/building/storage
 */
const appConfig = {
    /* Event Config */
    setEvent(event: any) {
        set('event', event)
    },
    async getEvent() {
        const event = await get('event')
        return event
    },
    removeEvent() {
        remove('event')
    },
    /* Place Config */
    setPlace(place: any) {
        set('place', place)
    },
    async getPlace() {
        return await get('place')
    },
    setSlug(slug: any) {
        set('slug', slug)
    },
    async getSlug() {
        return await get('slug')
    },
    /* Games Config */
    setGames(games: any) {
        set('games', games)
    },
    async getGames() {
        return await get('games')
    },
    removeGames() {
        remove('games')
    },
    setGameFromPage(page: string) {
        //set('prevGamePage', page)
        set('prevGamePage', 'discover')
    },
    async getGameFromPage() {
        return await get('prevGamePage')
    },
    /* Home Ads Config */
    setAdsConfig(adsConfig: { placeId: string, areaId: string }) {
        set('adsConfig', adsConfig)
    },
    async getAdsConfig() {
        return await get('adsConfig') as {placeId: string, areaId: string}
    },
    setAds(ads: any) {
        set('ads', ads)
    },
    async getAds() {
        return await get('ads')
    },
    /* Test mode (prévisualisation via /e/:slug) */
    setTestMode(isTest: boolean) {
        set('testMode', isTest)
    },
    async getTestMode() {
        return await get('testMode')
    },
    removeTestMode() {
        remove('testMode')
    },
    //Anim
    setHomePremAnim(homePremAnim: any) {
        set('homeAnimPrem', homePremAnim)
    },
    async getHomePremAnim() {
        return await get('homeAnimPrem')
    },
    setAnim(ads: any) {
        set('homeAnim', ads)
    },
    async getAnim() {
        return await get('homeAnim')
    },
    removeAllConfig() {
        remove('place')
        remove('qr')
        remove('event')
        remove('adsConfig')
        remove('global') // ancien cache des CGU globales (supprimées le 08/10)
        remove('ads')
        remove('homeAnimPerm')
        remove('homeAnim')
        remove('slug')
        remove('prevGamePage')
        remove('testMode')
    },
}

export default appConfig
